require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/floors/services/decathlon-services.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/floors/services/decathlon-services.legacy.js
// module id = 688
// module chunks = 31